import {ID, WithChildren} from "../../../../_metronic/helpers";
import {createContext, Dispatch, FC, SetStateAction, useContext, useState} from "react";
import {TicketContentModel, TicketModel} from "./_model";

export type TicketContextProps = {
    itemIdForUpdate?: TicketModel | undefined
    setItemIdForUpdate: Dispatch<SetStateAction<TicketModel | undefined>> ,
    Tickets : TicketModel[] ,
    setTickets :  Dispatch<SetStateAction< TicketModel[]>> ,
    TicketsContent : TicketContentModel[] ,
    setTicketContent :  Dispatch<SetStateAction< TicketContentModel[]>> ,
    listQueryRequest : {page : number , items_per_page : number , search : string,last_page :number,total : number},
    setListQueryRequest : Dispatch<SetStateAction< {page : number , items_per_page : number , search : string,last_page :number,total : number}>>
}
export const initialTicketContext: TicketContextProps = {
    setItemIdForUpdate: () => {},
    setTickets : () =>{},
    Tickets : [] ,
    setTicketContent : ()=>{},
    TicketsContent : [],
    listQueryRequest :{page : 1 , items_per_page : 10 , search : '',last_page : 1,total : 0} ,
    setListQueryRequest : ()=>{}
}
const TicketContext = createContext<TicketContextProps>(initialTicketContext);


export {TicketContext}